/**
 * The project page's tab, read back from its `?tab=` (HW-983). The page writes
 * the tab there on every switch; reading it back is what lets the browser's Back
 * from a board land on the Boards tab it was opened from, rather than on
 * Dashboard. Anything that is not one of `tabs` — a stale link, a tab the
 * reader may not see — falls back to `fallback`.
 */
export function tabFromSearch<T extends string>(search: string, tabs: readonly T[], fallback: T): T {
  const asked = new URLSearchParams(search).get('tab');
  return tabs.find((tab) => tab === asked) ?? fallback;
}
